<template>
  <div>
    <p class="center ninety-green" v-if="message" key="message">
      {{ message }}
    </p>
    <p
      v-if="error && getType(error) === 'string'"
      key="error"
      class="center ninety-red"
    >
      {{ error }}
    </p>
    <div v-if="getType(error) === 'object'" key="error-list">
      <div v-for="key in errorKeys" :key="key">
        <br />
        <div>
          <span class="error center" v-for="(item, index) in getErrors(key)" :key="`${key}-${index}-error`">
            {{ item }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlashMessage",
  props: {
    message: {
      type: String,
      default: null,
    },
    error: {
      type: [Object, String],
      default: null,
    },
  },
  computed: {
    errorKeys() {
      if (!this.error || this.getType(this.error) === "string") {
        return [];
      }
      return Object.keys(this.error);
    },
  },
  methods: {
    getErrors(key) {
      return this.error[key];
    },
    getType(obj) {
      return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    },
  },
  filters: {
    titleCase(value) {
      return value.replace("_", " ");
    },
  },
};
</script>
